/**
 * Money formatting helpers.
 *
 * Invoice amounts must render in the document's own currency (AT v1.9
 * FAR — an invoice can be USD/EUR/etc with TRM), never hardcoded COP.
 * Falls back to COP if the currency code is unknown to Intl so a bad
 * value never crashes the page over formatting.
 */

export function moneyFormatter(currency?: string): Intl.NumberFormat {
  try {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: currency || 'COP',
      maximumFractionDigits: 2,
    })
  } catch {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 2,
    })
  }
}

export function formatMoney(amount: string | number, currency?: string): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount
  return moneyFormatter(currency).format(n)
}
